import { HStack, VStack } from '@genial/components';
import { useBreakpointValue } from '@genial/utils';
import { Pressable } from 'native-base';
import React from 'react';

import { reportGeneratorTheme } from '../../constants/theme';

interface CarouselPageIndicatorsProps {
  pageCount: number;
  activePage: number;
  onPagePress: (page: number) => void;
}

export const CarouselPageIndicators: React.FC<CarouselPageIndicatorsProps> = ({
  pageCount,
  activePage,
  onPagePress,
}) => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const justifyContent = isMobile ? 'flex-start' : 'flex-end';
  const visiblePageCount = Math.max(pageCount, 1);

  return (
    <HStack
      width={isMobile ? 'full' : undefined}
      justifyContent={justifyContent}
      alignItems="center"
      space="inline.xxxs"
      flexShrink={0}>
      {Array.from({ length: visiblePageCount }).map((_, index) => (
        <Pressable
          key={`carousel-page-${index}`}
          onPress={() => onPagePress(index)}
          accessibilityRole="button"
          accessibilityLabel={`Ir para a página ${index + 1} do carrossel`}
          disabled={visiblePageCount <= 1}>
          <VStack
            width={index === activePage || visiblePageCount <= 1 ? '34px' : '28px'}
            height={6}
            borderRadius={4}
            bg={
              index === activePage || visiblePageCount <= 1
                ? reportGeneratorTheme.carousel.dotActive
                : reportGeneratorTheme.carousel.dotInactive
            }
          />
        </Pressable>
      ))}
    </HStack>
  );
};
